export interface INotesTypesListDelegate {
    onAddOrUpdateNotesTypeClicked(): void;
}
